import "./Footer.scss";
import { useContext } from "react";
import { Link } from "react-router-dom";
import { LangContext } from "../../context/langContext";
import logo from "../../assets/logo.png";
import LangSelect from "../LangSelect/LangSelect";

const Footer = ({ textData, changeLang }) => {
  const lang = useContext(LangContext);

  return (
    <footer className="footer">
      <div className="footer__wrapper">
        <div className="footer__left-container">
          <Link to="/" className="logo-wrapper">
            <img
              src={logo}
              className="logo logo_footer"
              alt={textData[lang].logo}
            />
          </Link>
          <div className="footer__contacts footer__contacts_mobile">
            <Link
              to="https://www.instagram.com/totem.chat/"
              className="footer__contacts-item footer__contacts-item_instagram"
              target="_blank"
              rel="noreferrer"
            ></Link>
            <a
              href="mailto: hello@thetotemchat.com"
              className="footer__contacts-item footer__contacts-item_email"
              title="hello@thetotemchat.com"
            >
              {" "}
            </a>
          </div>
        </div>
        <ul className="footer__list">
          <li className="footer__list-section">
            <Link to="/help/privacy" className="footer__list-item">
              {textData[lang].footer.privacy}
            </Link>
            <Link to="/help/terms" className="footer__list-item">
              {textData[lang].footer.rules}
            </Link>
          </li>
          <li className="footer__list-section">
            <a href="#about" className="footer__list-item">
              {textData[lang].footer.about}
            </a>
            <a href="#download" className="footer__list-item">
              {textData[lang].footer.download}
            </a>
          </li>
          <li>
            <LangSelect
              className="lang-select_show-on-mobile"
              changeLang={changeLang}
            />
          </li>
        </ul>
        <div className="footer__contacts footer__contacts_desktop">
          <Link
            to="https://www.instagram.com/totem.chat/"
            className="footer__contacts-item footer__contacts-item_instagram"
            target="_blank"
            rel="noreferrer"
          >
            {" "}
          </Link>
          <a
            href="mailto: hello@thetotemchat.com"
            className="footer__contacts-item footer__contacts-item_email"
            title="hello@thetotemchat.com"
          >
            {" "}
          </a>
        </div>
        <LangSelect
          className="lang-select_hide-on-mobile"
          changeLang={changeLang}
          isDropdown
        />
      </div>
      <p className="footer__copyright">
        &copy;
        {textData[lang].footer.copyright}
      </p>
    </footer>
  );
};

export default Footer;
